import React, { useState, useEffect } from "react";
import api from "../../api/api";

const AddApiKeyForm = () => {
  const [keyName, setKeyName] = useState("");
  const [keyValue, setKeyValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false); // For toggling update form
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Fetch existing API key data when component mounts
  useEffect(() => {
    const fetchApiKey = async () => {
      setLoading(true);
      try {
        const response = await api.get("/setting/get/key");

        // Check if data array exists and has at least one element
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          const apiKey = response.data[0];
          setKeyName(apiKey.key_name || "");
          setKeyValue(apiKey.key_value || "");
          setIsEditing(true);
        } else if (
          response.data &&
          response.data.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          // In case response is wrapped in an object with a data property
          const apiKey = response.data.data[0];
          setKeyName(apiKey.key_name || "");
          setKeyValue(apiKey.key_value || "");
          setIsEditing(true);
        } else {
          setIsEditing(false);
        }
      } catch (error) {
        console.error("Failed to fetch API key:", error);
        setMessage("Failed to fetch API Key");
      } finally {
        setLoading(false);
        setInitialDataLoaded(true);
      }
    };

    fetchApiKey();
  }, []);

  // Handle form submit for adding new key
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      await api.post("/setting/add/key", {
        key_name: keyName,
        key_value: keyValue,
      });
      setMessage("API Key saved successfully!");
      setIsEditing(true); // Switch to update mode after adding
    } catch (error) {
      console.error(error);
      setMessage("Failed to save API Key");
    } finally {
      setLoading(false);
    }
  };

  // Handle form submit for updating existing key
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      await api.post("/setting/add/key", {
        key_name: keyName,
        key_value: keyValue,
      });
      setMessage("API Key updated successfully!");
    } catch (error) {
      console.error(error);
      setMessage("Failed to update API Key");
    } finally {
      setLoading(false);
    }
  };

  // Show loading or error while initial data is loading
  if (!initialDataLoaded) {
    return <p>Loading...</p>;
  }

  return (
    <section className="employee-section add-employee-001">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>{isEditing ? "Update API Key" : "Add API Key"}</h2>
        </div>
        <div className="add-wrapper">
          <div className="content-wrapper">
            <h2>
              {isEditing ? "Update API Key Details" : "Add API Key Details"}
            </h2>

            {isEditing ? (
              <form onSubmit={handleUpdateSubmit}>
                <div>
                  <label>Key Name:</label>
                  <input
                    type="text"
                    value={keyName}
                    onChange={(e) => setKeyName(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Key Value:</label>
                  <input
                    type="text"
                    value={keyValue}
                    onChange={(e) => setKeyValue(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" disabled={loading}>
                  {loading ? "Updating..." : "Update API Key"}
                </button>
                {message && <p>{message}</p>}
              </form>
            ) : (
              <form onSubmit={handleAddSubmit}>
                <div>
                  <label>Key Name:</label>
                  <input
                    type="text"
                    value={keyName}
                    onChange={(e) => setKeyName(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label>Key Value:</label>
                  <input
                    type="text"
                    value={keyValue}
                    onChange={(e) => setKeyValue(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" disabled={loading}>
                  {loading ? "Saving..." : "Save API Key"}
                </button>
                {message && <p>{message}</p>}
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddApiKeyForm;
